import {Container, Text} from '@inlet/react-pixi';
import {DisplayObjectList} from '../../components/DisplayObjectList';
import {ToggleButtonWithTitle} from '../../components/ToggleButtonWithTitle';
import * as React from 'react';
import {TextStyle} from 'pixi.js';

const style = new TextStyle({
    fontFamily: 'Arial',
    fontSize: 80,
    fontWeight: 'bold',
    align: 'center',
    fill: '#ffffff'
});

type FiltersGroupProps = {
    name?: string;
    width: number;
    filters: string[];
    selectedFilters: string[];
    onSelect: (filterName: string) => void;
};

export function FiltersGroup({name, width, filters, selectedFilters, onSelect}: FiltersGroupProps): JSX.Element {
    return (
        <Container >
            {name ? <Text text={name} y={80} style={style} anchor={0.5} x={width / 2}/> : undefined}
            <DisplayObjectList y={name ? 160 : 0} direction={'row'} gapBetweenChildren={20} wrap={width - 500}>
                {filters.map(filter => {
                    return <ToggleButtonWithTitle
                        key={filter}
                        title={filter}
                        onChange={() => onSelect(filter)}
                        width={'auto'}
                        height={200}
                        fontSize={50}
                        value={selectedFilters.some(selected => selected === filter)}
                    />;
                })}
            </DisplayObjectList>
        </Container>
    );
}
